import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Score } from 'huddyapi';
import { SavedAssignment } from '../compass-library-manage-dialog/compass-library-manage-dialog.component';

@Component({
  selector: 'listing-component',
  templateUrl: 'listing.component.html',
  styleUrls: ["./listing.component.scss"]
})
export class Listing {
  @Input() title: string;
  @Input() desc: string;
  @Input() hasDesc: boolean = true;
  @Input() extraDescs: string[] = [];
  @Input() descTwo: string;
  @Input() avatarText: string;
  @Input() photoURL: string;
  @Input() aboveTitle: string;
  @Input() longTitleSkeleton: boolean = false;
  @Input() measurement: string;
  @Input() measurementColor: string;
  @Input() time: string;
  @Input() rightText: string;
  @Input() selected: boolean = false;
  @Input() isDirty: boolean = false;
  @Input() hasError: boolean = false;
  @Input() skeleton: boolean = false;
  @Input() underline: boolean = true;
  @Input() padding: boolean = true;
  @Input() selectable: boolean = true;
  @Input() canEdit: boolean = false;
  @Input() noFillAvatar: boolean = false;
  @Input() hasAvatar: boolean = true;
  @Input() donutAvatar: boolean = false;
  @Input() avatarDonutValue: number = 0;
  @Input() avatarDonutColor: string = '#a3d3ff';
  @Input() smallAvatar: boolean = false;
  @Input() smallSpacing: boolean = false;
  @Input() network: boolean = false;
  @Input() needsScores: boolean = false;
  @Input() scores: any;
  @Input() large: boolean = false;
  @Input() buttonUrl: string;
  @Input() buttonDisabled: boolean = false;
  @Input() dotColor: string;
  @Input() disabled: boolean = false;
  @Input() scoredAssignment: SavedAssignment;
  @Output() editClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output() buttonClicked: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  editHandler(event: MouseEvent) {
    if(this.disabled)
      return;
    event.stopPropagation();
    this.editClicked.emit();
  }

  buttonHandler(event: MouseEvent) {
    if(this.disabled || this.buttonDisabled)
      return;
    event.stopPropagation();
    this.buttonClicked.emit();
  }

  getScore(type: string): number {
    if(!this.scores)
      return null;
    const score: Score = this.scores[type];
    return score ? Math.floor(score.score || 0) : 0;
  }
}
